var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpGoodscolorchangeActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#A3D7FF;}\r\n\t.st2{fill:#006EFF;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1024,
    height: 1024
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240,832h256l0,0v112c0,8.8-7.2,16-16,16H256c-8.8,0-16-7.2-16-16V832L240,832z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368,64c-89.3,0.1-177.2,22.1-256,64l64,256l64,384h256l64-384l64-256C545.2,86.1,457.3,64.1,368,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M644.6,320L644.6,320C465.3,320,320,463.3,320,640s145.3,320,324.6,320h19.1c39.4,0.1,71.5-31.3,71.6-70.2 c0-17.1-6.2-33.7-17.6-46.5c-18.8-21.2-28.2-45.6-26.8-68.8c0.7-9.3,2.5-18.6,5.5-27.5c2.8-8.2,7.9-18.8,15.9-23.4 c2.1-1.2,3.9-1.8,7.8-1.8c6,0,14.3,1.5,24,3.2c15.1,2.7,33.9,6.1,56.4,6.1c9.5,0,18.9-0.6,28.3-1.8c1.2-0.2,2.3-0.3,3.5-0.5 c81.7-11.9,138.1-86.9,126-167.4c-1.4-9.4-3.8-18.7-7-27.6C905.5,405.6,782.5,319.9,644.6,320z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 644.8,
    cy: 445.3,
    rx: 34.9,
    ry: 34.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 772.6,
    cy: 491.1,
    rx: 34.9,
    ry: 34.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 517,
    cy: 491.1,
    rx: 34.9,
    ry: 34.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 458.9,
    cy: 582.7,
    rx: 34.9,
    ry: 34.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpGoodscolorchangeActive);
export default __webpack_public_path__ + "static/media/hp_goodscolorchange_active.7bc8725e0c6df80e46040e1e234b4ed6.svg";
export { ForwardRef as ReactComponent };